import * as z from "zod/v4";
import { MarketingAgentAnalyticsInputSchema } from "./common";

const DecisionTimeSeriesPointSchema = z.object({
  date: z.string(), // YYYY-MM-DD format
  proceedCount: z.number(),
  skipCount: z.number(),
  reevaluateCount: z.number(),
  bypassedCount: z.number(),
});

export const getMarketingAgentDecisionTrends = {
  name: "getMarketingAgentDecisionTrends" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.array(DecisionTimeSeriesPointSchema),
};
